import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class NumberedShowcase extends UcoastEl {
	static htmlSelector = 'numbered-showcase'

	private toggles: HTMLButtonElement[] = []
	private panels: HTMLElement[] = []
	private isTouch = false

	override connectedCallback() {
		super.connectedCallback()

		this.isTouch = window.matchMedia('(hover: none)').matches
		this.toggles = Array.from(q.ol<HTMLButtonElement>('[data-feature-toggle]', this) ?? [])
		this.panels = Array.from(q.ol<HTMLElement>('[data-feature-panel]', this) ?? [])

		this.toggles.forEach((toggle) => {
			const index = toggle.dataset.featureToggle
			if (!index) return
			toggle.addEventListener('click', () => this.activate(index))
			toggle.addEventListener('focus', () => this.activate(index))
			if (!this.isTouch) {
				toggle.addEventListener('mouseenter', () => this.activate(index))
			}
		})
	}

	private activate(index: string) {
		if (this.dataset.activeIndex === index) return
		this.dataset.activeIndex = index

		this.toggles.forEach((t) => {
			t.setAttribute('aria-pressed', String(t.dataset.featureToggle === index))
		})

		this.panels.forEach((p) => {
			const active = p.dataset.featurePanel === index
			p.dataset.active = String(active)
			p.setAttribute('aria-hidden', String(!active))
		})
	}
}
